export default __webpack_public_path__ + "static/media/154.5475085b.png";